/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import divorceCostTeaser from "../../../../assets/img/guidebook/Teaser_Scheidungskosten_700px.jpg";
import divorceRequirementsTeaser from "../../../../assets/img/guidebook/Teaser_Trennungsjahr_700px.jpg";
import divorceAgreedTeaser from "../../../../assets/img/guidebook/Teaser_einvernehmliche-Scheidung_350px.jpg";
import divorceImportantTopicsTeaser from "../../../../assets/img/guidebook/Teaser_Themen-im-Überblick_350px.jpg";
import divorceDurationTeaser from "../../../../assets/img/guidebook/Teaser_Dauer_350px.jpg";
import divorcePensionsTeaser from "../../../../assets/img/guidebook/Teaser_Versorgungsausgleich_350px.jpg";
import divorceProcessCostSupportTeaser from "../../../../assets/img/guidebook/Teaser_Verfahrenskostenhilfe_350px.jpg";
import divorceThreeYearsSeparationTeaser from "../../../../assets/img/guidebook/Teaser_3-Jahre-Trennung_350px.jpg";
import divorceContentiousTeaser from "../../../../assets/img/guidebook/Teaser_streitige-Scheidung_350px.jpg";
import divorceHardshipTeaser from "../../../../assets/img/guidebook/Teaser_Haertefallscheidung_350px.jpg";
import divorceAttorneyDutyTeaser from "../../../../assets/img/guidebook/Teaser_Anwaltspflicht_350px.jpg";
import divorceAlimonyTeaser from "../../../../assets/img/guidebook/Teaser_Unterhalt_350px.jpg";
import divorceChildrenTeaser from "../../../../assets/img/guidebook/Teaser_Scheidung-mit-Kindern_350px.jpg";
import divorcePropertySchemeTeaser from "../../../../assets/img/guidebook/Teaser_Gütertrennung_350px.jpg";
import divorceCourtHearingTeaser from "../../../../assets/img/guidebook/Teaser_Gericht_350px.jpg";

const guidebookDivorceCosts = {
  linkTo: "/ratgeber/familienrecht/scheidungskosten",
  image: divorceCostTeaser,
  headline: "Wie viel kostet eine (einvernehmliche) Scheidung?",
  text: "Wir zeigen Ihnen, wie sich die Scheidungskosten zusammen setzen. Sie haben auf anderen Websites günstigere Preise entdeckt? Wir erklären ganz offen, warum ...",
  altTitle: "Scheidungskosten",
};

const guidebookDivorceRequirements = {
  linkTo: "/ratgeber/familienrecht/scheidungsvoraussetzungen",
  image: divorceRequirementsTeaser,
  headline: "Wann kann ich mich scheiden lassen?",
  text: "Was sind die Voraussetzungen für eine Scheidung? Wir erklären Ihnen das sogenannte Trennungsjahr und unter welchen Bedingungen Sie sich scheiden lassen können.",
  altTitle: "Scheidungsvoraussetzungen",
};

const guidebookAgreedDivorce = {
  linkTo: "/ratgeber/familienrecht/einvernehmliche-scheidung",
  image: divorceAgreedTeaser,
  headline: "Einfach erklärt: Einvernehmliche Scheidung",
  text: "Welche Vorteile bringt eine einvernehmliche Scheidung mit sich, wann handelt es sich um eine einvernehmliche Scheidung und was sollte ich mit meinem Partner abklären?",
  altTitle: "Einvernehmliche Scheidung",
};

const guidebookDivorceImportantTopics = {
  linkTo: "/ratgeber/familienrecht/wichtige-themen-ueberblick",
  image: divorceImportantTopicsTeaser,
  headline: "Alle wichtigen Themen im Überblick - Was kommt auf mich zu?",
  text: "Was muss ich bei einer einvernehmlichen Scheidung bedenken und welche Themen sollte ich mit meinem Partner abklären? Wir geben Ihnen einen Überblick über ...",
  altTitle: "Wichtige Themen im Überblick",
};

const guidebookDivorceDuration = {
  linkTo: "/ratgeber/familienrecht/scheidungsdauer",
  image: divorceDurationTeaser,
  headline: "Wie lange dauert eine Scheidung? Alles zum Ablauf",
  text: "Sie haben sich entschlossen sich scheiden zu lassen und fragen sich, wann Sie geschieden sein werden? Wir geben Ihnen einen Überblick über den Ablauf ...",
  altTitle: "Scheidungsdauer",
};

const guidebookDivorcePensions = {
  linkTo: "/ratgeber/familienrecht/versorgungsausgleich",
  image: divorcePensionsTeaser,
  headline: "Einfach erklärt: Versorgungsausgleich",
  text: "Bei einer Scheidung werden Sie früher oder später über den Versorgungsausgleich “stolpern”. Der Versorgungsausgleich ist für Sie vermutlich ein neuer Begriff ...",
  altTitle: "Versorgungsausgleich",
};

const guidebookDivorceProcessCostSupport = {
  linkTo: "/ratgeber/familienrecht/verfahrenskostenhilfe",
  image: divorceProcessCostSupportTeaser,
  headline: "Einfach erklärt: Verfahrenskostenhilfe",
  text: "Sie haben ein sehr geringes Einkommen und sind daher nicht sicher, ob Sie die Scheidung bezahlen können? In Deutschland gibt es die Verfahrenskostenhilfe, um ...",
  altTitle: "Verfahrenskostenhilfe",
};

const guidebookDivorceThreeYearsSeparation = {
  linkTo: "/ratgeber/familienrecht/scheidung-drei-jahre-trennung",
  image: divorceThreeYearsSeparationTeaser,
  headline: "Scheidung nach mehr als 3 Jahren Trennung",
  text: "Sie leben länger als drei Jahre von Ihrem Ex-Partner getrennt? Dann kann Ihre Scheidung sehr einfach durchgeführt werden.",
  altTitle: "Scheidung 3 Jahre Trennung",
};

const guidebookContentiousDivorce = {
  linkTo: "/ratgeber/familienrecht/streitige-scheidung",
  image: divorceContentiousTeaser,
  headline: "Einfach erklärt: Streitige Scheidung",
  text: "Sie haben Streitigkeiten mit Ihrem Ex-Partner und können sich daher nicht einigen? Hier finden Sie alles zur streitigen Scheidung.",
  altTitle: "Streitige Scheidung",
};

const guidebookHardshipDivorce = {
  linkTo: "/ratgeber/familienrecht/haertefallscheidung",
  image: divorceHardshipTeaser,
  headline: "Einfach erklärt: Härtefallscheidung",
  text: "In Härtefällen kann eine Scheidung auch früher als nach einem Jahr der Trennung durchgeführt werden. Wann ein Härtefall vorliegt, erfahren Sie hier kurz zusammengefasst.",
  altTitle: "Härtefallscheidung",
};

const guidebookAttorneyDuty = {
  linkTo: "/ratgeber/familienrecht/anwaltspflicht",
  image: divorceAttorneyDutyTeaser,
  headline: "Einfach erklärt: Anwaltspflicht",
  text: "Benötigen Sie zur Scheidung einen Anwalt? Das Wichtigste vorweg: In Deutschland wird immer mindestens ein Anwalt benötigt, um eine Scheidung durchzuführen.",
  altTitle: "Anwaltspflicht",
};

const guidebookDivorceAlimony = {
  linkTo: "/ratgeber/familienrecht/unterhalt",
  image: divorceAlimonyTeaser,
  headline: "Alles zum Thema Unterhalt",
  text: "Wenn Sie sich scheiden lassen möchten, kommt schnell die Frage nach den damit verbundenen Kosten auf. Entscheidend sind hierbei die Unterhaltszahlungen, die ...",
  altTitle: "Unterhalt",
};

const guidebookDivorceChildren = {
  linkTo: "/ratgeber/familienrecht/scheidung-mit-kindern",
  image: divorceChildrenTeaser,
  headline: "Tipps für eine Scheidung mit Kindern",
  text: "Wie lasse ich mich ohne zu viele negative Auswirkungen auf meine Kinder scheiden und was ist rechtlich zu beachten? Wir geben Ihnen Tipps für eine friedliche ...",
  altTitle: "Scheidung mit Kindern",
};

const guidebookDivorcePropertyScheme = {
  linkTo: "/ratgeber/familienrecht/gueterstand",
  image: divorcePropertySchemeTeaser,
  headline: "Wie wird der Besitz aufgeteilt? Alles zum Thema Gütertrennung",
  text: "Bei einer Scheidung ist es sehr wichtig zu wissen, wie die gemeinsamen Besitztümer und das Vermögen aufgeteilt werden. Wem das in die Ehe eingebrachte und ...",
  altTitle: "Güterstand",
};

const guidebookDivorceCourtHearing = {
  linkTo: "/ratgeber/familienrecht/gerichtstermin",
  image: divorceCourtHearingTeaser,
  headline: "Perfekt informiert zum Scheidungstermin",
  text: "Sie sind fast am Ziel: das Gericht hat Ihnen einen Scheidungstermin zugewiesen. Doch wie verläuft der Termin vor Gericht und was müssen Sie beachten? Damit Sie ...",
  altTitle: "Gerichtstermin",
};

export {
  guidebookDivorceCosts,
  guidebookDivorceRequirements,
  guidebookAgreedDivorce,
  guidebookDivorceImportantTopics,
  guidebookDivorceDuration,
  guidebookDivorcePensions,
  guidebookDivorceProcessCostSupport,
  guidebookDivorceThreeYearsSeparation,
  guidebookContentiousDivorce,
  guidebookHardshipDivorce,
  guidebookAttorneyDuty,
  guidebookDivorceAlimony,
  guidebookDivorceChildren,
  guidebookDivorcePropertyScheme,
  guidebookDivorceCourtHearing,
};
